import HNSColors from "../../../ui library/HNSColors";

export const actionButtonSizeSx = {
  borderRadius: "500px",
  textTransform: "none",
  fontWeight: 400,
  fontSize: "14px",
  boxShadow: "none",
  paddingLeft: 3,
  paddingRight: 3,
  minWidth: 220,
  height: 40,
};

export const serviceCardSx = {
  border: `1px solid ${HNSColors.primary[900]}`,
  borderRadius: 3,
  padding: 3,
  marginTop: 4,
  marginBottom: 4,
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
  boxShadow: "none",
  background: "#fff",
  maxWidth: 700,
};

export const amountTypographySx = {
  fontSize: "1.3rem",
  color: HNSColors.neutrals[500],
  minWidth: 80,
};

export const documentContainerBgSx = {
  background: HNSColors.tertiary[900],
};

export const documentPreviewBoxSx = {
  minHeight: "50vh",
  maxWidth: 320,
  background: "#fff",
  borderRadius: 2,
  boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
  mb: 3,
  mt: 2,
  overflow: "hidden",
};

export const sectionSubtitleSx = {
  fontWeight: 600,
  fontSize: "20px",
  color: HNSColors.primary[800],
  textAlign: "left",
};
